module.exports = __webpack_public_path__ + "static/media/text.c297fb80.jpeg";